<template>
    <div :class="{ 'public-qvp-bg': showPublicBackground }">
    <div class="section pt-1 mt-2">
        <div class="wallet-card">
            <div class="wallet-footer">
                <ul class="nav nav-tabs lined" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: current_tab === 'general' }" data-bs-toggle="tab" href="javascript:void(0)" role="tab" @click="getQVPList('general')">
                            {{ $t('general') || 'ജനറൽ' }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: current_tab === 'teens' }" data-bs-toggle="tab" href="javascript:void(0)" role="tab" @click="getQVPList('teens')">
                            {{ $t('teens') || 'ടീൻസ്' }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: current_tab === 'kids' }" data-bs-toggle="tab" href="javascript:void(0)" role="tab" @click="getQVPList('kids')">
                            {{ $t('kids') || 'കിഡ്സ്' }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{ active: current_tab === 'global' }" data-bs-toggle="tab" href="javascript:void(0)" role="tab" @click="getQVPList('global')">
                            {{ $t('global') || 'ഗ്ലോബൽ' }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="section pt-0 mt-0">
        <div class="listed-detail mt-3">
            <h3 class="text-center mt-2 mal-text custom-title">{{ dynamicCategoryTitle }}</h3>
        </div>
    </div>
    
    <!-- QVP Registration Summary Card -->
    <div class="section mb-2" v-if="!loading && registrant_lists && registrant_lists.length > 0">
        <div class="card stat-box d-flex flex-row justify-content-around align-items-center p-2" style="gap: 10px;">
            <div>
                <div class="title mal-text">General</div>
                <div class="value text-primary">{{ categoryCount.general }}</div>
            </div>
            <div>
                <div class="title mal-text">Global</div>
                <div class="value text-success">{{ categoryCount.global }}</div>
            </div>
            <div>
                <div class="title mal-text">Teens</div>
                <div class="value text-warning">{{ categoryCount.teens }}</div>
            </div>
            <div>
                <div class="title mal-text">Kids</div>
                <div class="value text-info">{{ categoryCount.kids }}</div>
            </div>
            <div>
                <div class="title mal-text">Total</div>
                <div class="value text-secondary">{{ categoryCount.total }}</div>
            </div>
        </div>
    </div>
    
    <!-- Filter Section with Accordion -->
    <div class="section inset mt-1 mb-1" v-if="!loading">
        <div class="accordion" id="accordionQVPFilter">
            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#qvpFilterAccordion" aria-expanded="false">
                        <ion-icon name="filter-outline" role="img" class="md hydrated"
                            aria-label="filter outline"></ion-icon>
                        Filter
                    </button>
                </h2>
                <div id="qvpFilterAccordion" class="accordion-collapse collapse" :class="hasActiveFilters ? 'show' : ''"
                    data-bs-parent="#accordionQVPFilter" style="">
                    <div class="accordion-body">
                        <div id="filterContent" style="padding: 0px !important;">
                            <!-- District Filter (for State Admins only) -->
                            <div v-if="showDistrictFilter" class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_district">District</label>
                                    <select class="form-control custom-select" v-model="filters.district"
                                        name="filter_district" @change="onDistrictFilterChange">
                                        <option value="">---All---</option>
                                        <option v-for="district in districtsList" :key="district.id" :value="district.id">
                                            {{ district.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <!-- Zone Filter (for State and District Admins) -->
                            <div v-if="showZoneFilter" class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_zone">Zone</label>
                                    <select class="form-control custom-select" v-model="filters.zone"
                                        name="filter_zone" @change="onZoneFilterChange">
                                        <option value="">---All---</option>
                                        <option v-for="zone in zonesList" :key="zone.id" :value="zone.id">
                                            {{ zone.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <!-- Unit Filter (for State, District, and Zone Admins) -->
                            <div v-if="showUnitFilter" class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_unit">Unit</label>
                                    <select class="form-control custom-select" v-model="filters.unit"
                                        name="filter_unit">
                                        <option value="">---All---</option>
                                        <option v-for="unit in unitsList" :key="unit.id" :value="unit.id">
                                            {{ unit.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <!-- Registration Type Filter -->
                            <div class="form-group">
                                <div class="input-wrapper">
                                    <label class="label mal-text" for="filter_registration_type">Registration Type</label>
                                    <select class="form-control custom-select" v-model="filters.registration_type"
                                        name="filter_registration_type">
                                        <option value="">---All---</option>
                                        <!-- Kids tab: Show "Public Registration" / "Admin Registration" -->
                                        <template v-if="current_tab === 'kids'">
                                            <option value="public">Public Registration</option>
                                            <option value="member">Admin Registration</option>
                                        </template>
                                        <!-- Other tabs: Show "Public" / "Member" -->
                                        <template v-else>
                                            <option value="public">Public</option>
                                            <option value="member">Member</option>
                                        </template>
                                    </select>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <button type="button" class="btn btn-danger btn-sm me-1 mb-1" style="width: 100%;"
                                        @click="clearFilters()">
                                        <ion-icon name="trash-bin-outline" role="img" class="md hydrated"
                                            aria-label="clear filters"></ion-icon>
                                        Clear
                                    </button>
                                </div>
                                <div class="col-6">
                                    <button type="button" class="btn btn-primary btn-sm me-1 mb-1" style="width: 100%;"
                                        @click="applyFilters()">
                                        <ion-icon name="search-outline" role="img" class="md hydrated"
                                            aria-label="apply filters"></ion-icon>
                                        Filter
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="section-heading">
        <div style="display: flex; justify-content: space-between; align-items: center;">
            <button type="button" class="btn btn-success btn-sm me-1 mb-1" @click="downloadPDF" v-if="false && permissions && permissions.download">
                <ion-icon name="download-outline"></ion-icon>
                {{ $t('download_pdf') || 'Download PDF' }}
            </button>
            <!-- Add Kids Registration Button - Only show for kids tab and admins -->
            <button type="button" 
                    class="btn btn-primary btn-sm mb-1" 
                    @click="openKidsRegistrationModal"
                    v-if="current_tab === 'kids' && currentUser && (currentUser.user_level <= 4)">
                <ion-icon name="add-outline"></ion-icon>
                {{ $t('add_kids') || 'Add Kids' }}
            </button>
        </div>
    </div>
    
    <div class="listview-title mt-0 mal-text custom-title">
        {{ $t('list') || 'ലിസ്റ്റ്' }}
    </div>
    
    <div class="section text-center" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>
    
    <div class="section">
        <div class="card">
            <h4 class="text-center mt-1 mal-text error-feedback" v-if="!loading_list && message">{{message}}</h4>
        </div>
    </div>
    
    <!-- Search Section -->
    <div class="search-section">
        <div class="search-box">
            <div class="input-wrapper">
                <input type="text" 
                       class="form-control search-input" 
                       v-model="search_query" 
                       @input="handleSearch"
                       :placeholder="'Search by name or mobile number'"
                       autocomplete="off">
                <ion-icon name="search-outline" class="search-icon"></ion-icon>
                <button type="button" 
                        class="clear-search-btn" 
                        v-if="search_query" 
                        @click="clearSearch">
                    <ion-icon name="close-circle"></ion-icon>
                </button>
            </div>
        </div>
    </div>
    
    <ul class="listview image-listview inset text" v-if="!loading_list">
        <li v-for="(registrant, index) in currentRegistrantList" :key="registrant.id" 
            :class="['list-item-container', { 'public-registrant': current_tab === 'kids' && isPublicRegistration(registrant) }]">
            <div class="item-content">
                <a href="javascript:void(0)" class="item">
                    <span class="sl-no">{{(pagination_data[current_tab].from + index)}}</span>
                    <img src="assets/img/sample/avatar/avatar1.png" alt="image" class="image">
                    <div class="in">
                        <div class="min-width-50">
                            <b>{{ registrant.name || '' }}</b>
                            <footer class="text-primary">
                                {{ registrant.mobile ? (registrant.country_code || '') + ' ' + registrant.mobile : '' }}
                                <span v-if="registrant.place" class="mal-text"> | {{ registrant.place }}</span>
                                <span v-if="registrant.age" class="mal-text"> | Age: {{ registrant.age }}</span>
                                <span v-if="registrant.gender" class="mal-text"> | {{ registrant.gender }}</span>
                                <span v-if="registrant.category" class="mal-text text-success">
                                    <br>{{ getCategoryDisplayName(registrant.category, registrant.kids_subcategory) }}
                                </span>
                                <span v-if="registrant.payment_status" class="mal-text">
                                    <br>
                                    <span :class="registrant.payment_status === 'Paid' ? 'text-success' : 'text-danger'">
                                        Payment: {{ registrant.payment_status === 'Paid' ? 'Paid' : 'Not Paid' }}
                                    </span>
                                </span>
                                <span v-if="registrant.unit" class="mal-text">
                                    <br>{{ registrant.unit.name_mal || registrant.unit.name }}
                                </span>
                            </footer>
                        </div>
                    </div>
                </a>
                <!-- Default Action Sheet Inset -->
                <div class="card-button dropdown" @click.stop>
                    <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal"
                        :data-bs-target="'#actionSheetInset'+registrant.id" @click="showActionModel">
                        <ion-icon name="ellipsis-horizontal"></ion-icon>
                    </button>
                </div>
            </div>
        </li>
    </ul>
    
    <!-- Action Sheet Modals -->
    <div v-for="registrant in currentRegistrantList" :key="'modal-' + registrant.id">
        <div class="modal fade action-sheet" :id="'actionSheetInset'+registrant.id" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $t('action') || 'Action' }}</h5>
                    </div>
                    <div class="modal-body">
                        <ul class="action-button-list">
                            <li v-if="registrant.mobile">
                                <a :href="'tel:'+registrant.mobile" class="btn btn-list">
                                    <span>
                                        <ion-icon name="call-outline"></ion-icon> {{ $t('call') || 'Call' }}
                                    </span>
                                </a>
                            </li>
                            
                            <li v-if="registrant.whatsapp">
                                <a :href="'https://wa.me/'+registrant.whatsapp_country_code+registrant.whatsapp+'?text='" class="btn btn-list">
                                    <span>
                                        <ion-icon name="logo-whatsapp"></ion-icon> {{ $t('whatsapp') || 'WhatsApp' }}
                                    </span>
                                </a>
                            </li>
                            
                            <!-- Payment Status: Kids = admins; General/Global/Teens = admins (Razorpay) or allowed list (Update Paid/Not Paid) -->
                            <li v-if="(registrant.category === 'kids' && isAdmin) || (['general', 'global', 'teens'].includes(registrant.category) && (isAdmin || canUpdatePayment))" class="action-divider"></li>
                            <li v-if="(registrant.category === 'kids' && isAdmin) || (['general', 'global', 'teens'].includes(registrant.category) && (isAdmin || canUpdatePayment))">
                                <a href="javascript:void(0)" @click="openPaymentStatusModal(registrant)" class="btn btn-list" data-bs-dismiss="modal">
                                    <span>
                                        <ion-icon name="card-outline"></ion-icon> {{ $t('payment_status') || 'Payment Status' }}
                                    </span>
                                </a>
                            </li>
                            
                            <li class="action-divider"></li>
                            <li>
                                <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                    <span>
                                        <ion-icon name="close-outline"></ion-icon> {{ $t('cancel') || 'Cancel' }}
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- * Action Sheet Modals -->
    
    <div class="section mt-2" v-if="!loading_list">
        <vue-awesome-paginate v-if="pagination_data[current_tab].total > 0" 
            :total-items="pagination_data[current_tab].total"
            :items-per-page="pagination_data[current_tab].per_page" 
            :max-pages-shown="3" 
            v-model="pagination_data[current_tab].current_page"
            :on-click="handlePageChange" 
            :show-ending-buttons="true" 
            :show-breakpoint-buttons="false" />
    </div>
    
    <!-- Kids Registration Modal - Slides from bottom -->
    <div class="kids-registration-modal" :class="{ 'modal-open': showKidsModal }" @click.self="closeKidsModal">
        <div class="modal-content-bottom" @click.stop>
            <div class="modal-header-bottom">
                <h5 class="modal-title mal-text">കിഡ്സ് രജിസ്ട്രേഷൻ (Kids Registration)</h5>
            </div>
            <div class="modal-body-bottom">
                <form @submit.prevent="handleKidsRegistration">
                    <!-- Child Name -->
                    <div class="form-group">
                        <label class="form-label mal-text">Child Name (കുട്ടിയുടെ പേര്) <span style="color: #dc2626;">*</span></label>
                        <input type="text" v-model="kidsForm.name" class="form-control" placeholder="Enter child name" required>
                    </div>

                    <!-- Age and Gender -->
                    <div style="display: flex; gap: 15px;">
                        <div class="form-group" style="flex: 1; min-width: 0;">
                            <label class="form-label mal-text">Age (പ്രായം) <span style="color: #dc2626;">*</span></label>
                            <input type="number" v-model="kidsForm.age" class="form-control" placeholder="Age" min="1" max="12" required @input="handleKidsAgeChange">
                        </div>
                        <div class="form-group" style="flex: 1; min-width: 0;">
                            <label class="form-label mal-text">Gender <span style="color: #dc2626;">*</span></label>
                            <select v-model="kidsForm.gender" class="form-control" required>
                                <option value="" disabled>Select Gender</option>
                                <option value="M">Male (പുരുഷൻ)</option>
                                <option value="F">Female (സ്ത്രീ)</option>
                            </select>
                        </div>
                    </div>

                    <!-- Kids Category (Auto-selected based on age) -->
                    <div class="form-group">
                        <label class="form-label mal-text">
                            Kids Category <span style="color: #dc2626;">*</span>
                            <span v-if="kidsForm.kids_subcategory" style="color: #28a745; font-size: 12px; margin-left: 8px;">(Auto-selected)</span>
                        </label>
                        <select v-model="kidsForm.kids_subcategory" class="form-control" required>
                            <option value="" disabled>Select Category</option>
                            <option value="junior">Junior - Born after 2017</option>
                            <option value="senior">Senior - Born after 2014</option>
                        </select>
                    </div>

                    <!-- Parent Name -->
                    <div class="form-group">
                        <label class="form-label mal-text">Parent Name (മാതാപിതാവിന്റെ പേര്) <span style="color: #dc2626;">*</span></label>
                        <input type="text" v-model="kidsForm.parent_name" class="form-control" placeholder="Enter parent name" required>
                    </div>

                    <!-- Parent Mobile -->
                    <div class="form-group">
                        <label class="form-label mal-text">Parent Mobile Number (മാതാപിതാവിന്റെ മൊബൈൽ) <span style="color: #dc2626;">*</span></label>
                        <input type="tel" v-model="kidsForm.parent_mobile" class="form-control" 
                            placeholder="10 digit mobile number" pattern="[0-9]{10}" maxlength="10" 
                            required>
                    </div>

                    <!-- District Selection - Only for State Admin (level 1 or 0) -->
                    <div class="form-group" v-if="isStateAdmin">
                        <label class="form-label mal-text">District (ജില്ല) <span style="color: #dc2626;">*</span></label>
                        <select v-model="kidsForm.district_id" class="form-control" required @change="handleDistrictChange" @input="handleDistrictChange">
                            <option value="" disabled>Select District</option>
                            <option v-for="district in allDistricts" :key="district.id" :value="district.id">
                                {{ district.name }}
                            </option>
                        </select>
                        <small class="text-muted" style="font-size: 11px; display: block; margin-top: 4px;" v-if="kidsForm.district_id">
                            Selected District ID: {{ kidsForm.district_id }} (Admin District: {{ currentUser?.district_id }})
                        </small>
                    </div>

                    <!-- Zone/Area Selection - Only for State Admin (after district selection) and District Admin -->
                    <div class="form-group" v-if="shouldShowZoneField">
                        <label class="form-label mal-text">Area (പ്രദേശം) <span style="color: #dc2626;">*</span></label>
                        <select v-model="kidsForm.zone_id" class="form-control" required @change="handleZoneChange" :key="`zone-select-${kidsForm.district_id || 'none'}`">
                            <option value="" disabled>Select Area</option>
                            <option v-for="zone in zones" :key="zone.id" :value="zone.id">
                                {{ zone.name }}
                            </option>
                        </select>
                    </div>

                    <!-- Unit Selection (required for Kids registration) -->
                    <div class="form-group" v-if="shouldShowKidsUnitField">
                        <label class="form-label mal-text">Unit (യൂണിറ്റ്) <span style="color: #dc2626;">*</span></label>
                        <select v-model="kidsForm.unit_id" class="form-control" required @change="handleUnitChange">
                            <option value="" disabled>Select Unit</option>
                            <option v-for="unit in kidsUnits" :key="unit.id" :value="unit.id">
                                {{ unit.name_mal || unit.name }}
                            </option>
                        </select>
                        <small v-if="kidsForm.zone_id && kidsUnits.length === 0" class="text-muted" style="font-size: 12px; margin-top: 4px; display: block;">
                            No units found for selected area.
                        </small>
                    </div>

                    <!-- Place Field - Only for Zone Admin -->
                    <div class="form-group" v-if="isZoneAdmin">
                        <label class="form-label mal-text">Place (സ്ഥലം) <span style="color: #dc2626;">*</span></label>
                        <input type="text" v-model="kidsForm.place" class="form-control" placeholder="Enter place" required>
                        <small class="text-muted" style="font-size: 12px; margin-top: 4px; display: block;">
                            District and Zone are auto-set from your profile
                        </small>
                    </div>

                    <!-- Submit Button -->
                    <div class="form-group" style="margin-top: 20px;">
                        <button type="submit" class="btn btn-primary btn-block" :disabled="loadingKidsRegistration">
                            <span v-if="!loadingKidsRegistration">Register</span>
                            <span v-else>Registering...</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
    
    <!-- Payment Status Modal -->
    <div class="modal fade action-sheet" id="paymentStatusModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Payment</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <!-- Kids: admins get Paid/Not Paid dropdown -->
                        <div v-if="selectedRegistrant && selectedRegistrant.category === 'kids' && isAdmin">
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label text-primary" for="payment_status">
                                        <span>{{ $t('payment_status') || 'Payment Status' }}</span>
                                        <span class="text-danger">*</span>
                                    </label>
                                    <select class="form-control custom-select" v-model="selectedPaymentStatus" id="payment_status">
                                        <option value="">{{ $t('select_payment_status') || 'Select Payment Status' }}</option>
                                        <option value="Paid">Paid</option>
                                        <option value="Pending">Not Paid</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group" v-if="paymentStatusMessage">
                                <div class="error-feedback">{{ paymentStatusMessage }}</div>
                            </div>
                            <div class="form-group basic">
                                <button type="button" @click="savePaymentStatus()" class="btn btn-primary btn-block btn-lg" :disabled="loading || !selectedPaymentStatus">
                                    <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                    <span>{{ $t('save') || 'Save' }}</span>
                                </button>
                                <button type="button" class="btn btn-secondary btn-block btn-lg mt-2" @click="closePaymentStatusModal" :disabled="loading">
                                    <span>{{ $t('cancel') || 'Cancel' }}</span>
                                </button>
                            </div>
                        </div>
                        <!-- General/Global/Teens: allowed list = Paid/Not Paid; admins = Razorpay Pay Now or Already Paid -->
                        <div v-else-if="selectedRegistrant && ['general', 'global', 'teens'].includes(selectedRegistrant.category)">
                            <!-- Manual update (Paid/Not Paid) for selected users in allowed list -->
                            <div v-if="canUpdatePayment">
                                <div class="form-group basic">
                                    <div class="input-wrapper">
                                        <label class="label text-primary" for="payment_status">
                                            <span>{{ $t('payment_status') || 'Payment Status' }}</span>
                                            <span class="text-danger">*</span>
                                        </label>
                                        <select class="form-control custom-select" v-model="selectedPaymentStatus" id="payment_status">
                                            <option value="">{{ $t('select_payment_status') || 'Select Payment Status' }}</option>
                                            <option value="Paid">Paid</option>
                                            <option value="Pending">Not Paid</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group" v-if="paymentStatusMessage">
                                    <div class="error-feedback">{{ paymentStatusMessage }}</div>
                                </div>
                                <div class="form-group basic">
                                    <button type="button" @click="savePaymentStatus()" class="btn btn-primary btn-block btn-lg" :disabled="loading || !selectedPaymentStatus">
                                        <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                        <span>{{ $t('save') || 'Save' }}</span>
                                    </button>
                                    <button type="button" class="btn btn-secondary btn-block btn-lg mt-2" @click="closePaymentStatusModal" :disabled="loading">
                                        <span>{{ $t('cancel') || 'Cancel' }}</span>
                                    </button>
                                </div>
                            </div>
                            <!-- Razorpay: Pay Now or Already Paid for admins -->
                            <div v-else-if="isAdmin">
                                <div v-if="selectedRegistrant.payment_status === 'Paid'" class="text-center p-3">
                                    <div class="iconbox text-success mb-3">
                                        <ion-icon name="checkmark-circle"></ion-icon>
                                    </div>
                                    <h3 class="text-success">{{ $t('paid') || 'Paid' }}</h3>
                                    <p class="text-muted">{{ $t('payment_already_completed') || 'Payment has been completed' }}</p>
                                    <button type="button" class="btn btn-secondary btn-block btn-lg mt-3" @click="closePaymentStatusModal">
                                        <span>{{ $t('close') || 'Close' }}</span>
                                    </button>
                                </div>
                                <div v-else>
                                    <div class="text-center mb-3">
                                        <h5 class="text-primary">Make Payment</h5>
                                        <p class="text-muted">Registration Fee: ₹{{ getRegistrationFee() }}</p>
                                    </div>
                                    <div class="form-group" v-if="paymentStatusMessage">
                                        <div class="alert alert-danger">{{ paymentStatusMessage }}</div>
                                    </div>
                                    <div class="form-group basic">
                                        <button type="button" @click="initiatePayment()" class="btn btn-primary btn-block btn-lg" :disabled="loading">
                                            <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                            <ion-icon name="card-outline" v-show="!loading"></ion-icon>
                                            <span>Pay Now (Razorpay)</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <!-- Alert Success/Error Action Sheet -->
    <div class="modal fade action-sheet" id="actionSheetAlert" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <!-- Success Icon -->
                        <div class="iconbox text-success" v-if="alertClass === 'alert-success'">
                            <ion-icon name="checkmark-circle"></ion-icon>
                        </div>
                        <!-- Error Icon -->
                        <div class="iconbox text-danger" v-if="alertClass === 'alert-error'">
                            <ion-icon name="close-circle"></ion-icon>
                        </div>
                        <!-- Message -->
                        <div class="text-center p-2">
                            <h3>{{ alertClass === 'alert-success' ? ($t('success') || 'Success') : ($t('error') || 'Error') }}</h3>
                            <p class="mal-text text-primary">{{ alertMessage }}</p>
                        </div>
                        <!-- Close Button -->
                        <a href="javascript:void(0)" class="btn btn-primary btn-lg btn-block" @click="closeAlertModal">
                            {{ $t('close') || 'Close' }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- * Alert Success/Error Action Sheet -->

</div>
</template>

<script>
import UserService from "../services/user.service";
import $ from 'jquery';

export default {
    name: 'QVP List',
    data() {
        return {
            loading: false,
            loading_list: false,
            message: "",
            permissions: {},
            current_tab: 'general',
            user_level: "",
            registrant_lists: [],
            grouped_registrants: {
                general: [],
                campus: [],
                teens: [],
                kids: [],
                global: []
            },
            alertMessage: '',
            alertClass: '',
            download_link: '',
            // Category counts from API (total across all pages)
            category_counts_from_api: {
                general: 0,
                global: 0,
                teens: 0,
                kids: 0,
                total: 0
            },
            // Pagination data for each tab
            pagination_data: {
                general: { current_page: 1, total: 0, per_page: 20, from: 1 },
                campus: { current_page: 1, total: 0, per_page: 20, from: 1 },
                teens: { current_page: 1, total: 0, per_page: 20, from: 1 },
                kids: { current_page: 1, total: 0, per_page: 20, from: 1 },
                global: { current_page: 1, total: 0, per_page: 20, from: 1 }
            },
            // Search functionality
            search_query: '',
            search_timeout: null,
            // Kids registration modal
            showKidsModal: false,
            loadingKidsRegistration: false,
            kidsForm: {
                name: '',
                age: '',
                gender: '',
                kids_subcategory: '',
                parent_name: '',
                parent_mobile: '',
                revenue_district_id: '',
                district_id: '',
                zone_id: '',
                unit_id: '',
                place: ''
            },
            revenueDistricts: [],
            allDistricts: [], // For state admin - all districts using district_id
            zones: [],
            kidsUnits: [],
            // Payment Status Modal
            selectedRegistrant: null,
            selectedPaymentStatus: '',
            paymentStatusMessage: '',
            canUpdatePayment: false,
            // Filter data
            filters: {
                district: '',
                zone: '',
                unit: '',
                registration_type: ''
            },
            // Dropdown lists for filters
            districtsList: [],
            zonesList: [],
            unitsList: []
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        isStateAdmin() {
            // Check route level first, then user level
            const routeLevel = parseInt(this.$route.params.sub_level || 0);
            const userLevel = parseInt(this.currentUser?.user_level || 0);
            // If viewing at state level (1 or 0) AND user is state admin, show state admin fields
            if (routeLevel === 1 || routeLevel === 0) {
                return userLevel === 1 || userLevel === 0;
            }
            // Otherwise, not state admin context
            return false;
        },
        isDistrictAdmin() {
            // Check route level first, then user level
            const routeLevel = parseInt(this.$route.params.sub_level || 0);
            const userLevel = parseInt(this.currentUser?.user_level || 0);
            // If viewing at district level (2), treat as district admin context
            if (routeLevel === 2) {
                return true;
            }
            // Otherwise check user's actual level
            return userLevel === 2;
        },
        isZoneAdmin() {
            // Check route level first, then user level
            const routeLevel = parseInt(this.$route.params.sub_level || 0);
            const userLevel = parseInt(this.currentUser?.user_level || 0);
            // If viewing at zone level (3), treat as zone admin context
            if (routeLevel === 3) {
                return true;
            }
            // Otherwise check user's actual level
            return userLevel === 3;
        },
        isUnitAdmin() {
            const routeLevel = parseInt(this.$route.params.sub_level || 0);
            const userLevel = parseInt(this.currentUser?.user_level || 0);
            if (routeLevel === 4) {
                return true;
            }
            return userLevel === 4;
        },
        isAdmin() {
            // Check if user is an admin (user_level >= 1 and <= 4)
            const userLevel = parseInt(this.currentUser?.user_level || 0);
            return userLevel >= 1 && userLevel <= 4;
        },
        shouldShowZoneField() {
            // For district admin, always show zone field
            if (this.isDistrictAdmin) {
                return true;
            }
            // For zone admin, don't show zone field (they only need place)
            if (this.isZoneAdmin) {
                return false;
            }
            // For state admin, show zone field when district is selected
            if (this.isStateAdmin) {
                return !!this.kidsForm.district_id;
            }
            return false;
        },
        shouldShowKidsUnitField() {
            // Unit is required for kids registration for admins at state/district/zone levels.
            // For unit admin, it will be auto-set and doesn't need selection.
            if (this.isUnitAdmin) return false;
            // For zone admin we still need unit selection (zone contains multiple units)
            if (this.isZoneAdmin) return true;
            // For district/state admins, show unit after zone is selected
            if (this.isDistrictAdmin || this.isStateAdmin) {
                return !!this.kidsForm.zone_id;
            }
            return false;
        },
        showPublicBackground() {
            const path = this.$route?.path || '';
            const isPublic = path === '/qvp' || path.startsWith('/qvp/');
            // Admin org pages should never show the public background
            const isOrgContext = path.includes('/org/');
            return isPublic && !isOrgContext;
        },
        categoryCount() {
            // Return category counts from API (total across all pages)
            // This ensures we show the correct total counts, not just current page counts
            return this.category_counts_from_api;
        },
        currentRegistrantList() {
            const result = this.grouped_registrants[this.current_tab] || [];
            return result;
        },
        dynamicCategoryTitle() {
            let categoryText = '';
            if (this.current_tab === 'general') {
                categoryText = 'ജനറൽ (General)';
            } else if (this.current_tab === 'campus') {
                categoryText = 'അൽ ബയാൻ (Al Bayan)';
            } else if (this.current_tab === 'teens') {
                categoryText = 'ടീൻസ് (Teens)';
            } else if (this.current_tab === 'kids') {
                categoryText = 'കിഡ്സ് (Kids)';
            } else if (this.current_tab === 'global') {
                categoryText = 'ഗ്ലോബൽ (Global)';
            }
            
            const level = parseInt(this.user_level ?? this.$route.params.sub_level);
            let levelText = '';
            
            if (level === 1 || level === 0) {
                levelText = 'സ്റ്റേറ്റ്';
            } else if (level === 2) {
                levelText = 'ജില്ല';
            } else if (level === 3) {
                levelText = 'മണ്ഡലം';
            } else if (level === 4) {
                levelText = 'യൂണിറ്റ്';
            }
            
            if (levelText && categoryText) {
                return levelText + ' ' + categoryText + ' QVP രജിസ്ട്രേഷൻ';
            } else if (categoryText) {
                return categoryText + ' QVP രജിസ്ട്രേഷൻ';
            }
            return 'QVP രജിസ്ട്രേഷൻ';
        },
        hasActiveFilters() {
            return this.filters.district || this.filters.zone || this.filters.unit || this.filters.registration_type;
        },
        showDistrictFilter() {
            // Show district filter for state admins only (level 1 or 0)
            // District admins and below should not see this filter
            const userLevel = this.user_level ?? parseInt(this.currentUser?.user_level || 0);
            return userLevel === 1 || userLevel === 0;
        },
        showZoneFilter() {
            // Show zone filter for state admins and district admins only
            // Zone admins should not see this filter (they already have a specific zone)
            const userLevel = this.user_level ?? parseInt(this.currentUser?.user_level || 0);
            return userLevel === 1 || userLevel === 0 || userLevel === 2;
        },
        showUnitFilter() {
            // Show unit filter for state, district, and zone admins
            const userLevel = this.user_level ?? parseInt(this.currentUser?.user_level || 0);
            return userLevel === 1 || userLevel === 0 || userLevel === 2 || userLevel === 3;
        }
    },
    watch: {
        'kidsForm.district_id'(newVal, oldVal) {
            console.log('🔍 WATCHER: kidsForm.district_id changed from', oldVal, 'to', newVal);
            if (newVal && newVal !== oldVal && this.isStateAdmin) {
                console.log('🔍 Watcher detected district change, calling handleDistrictChange');
                // Small delay to ensure v-model has updated
                this.$nextTick(() => {
                    this.handleDistrictChange();
                });
            }
        }
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
        } else {
            console.log('🔍 Mounted - Full route:', this.$route);
            console.log('🔍 Mounted - Route params:', this.$route.params);
            console.log('🔍 Mounted - Route path:', this.$route.path);
            
            this.user_level = parseInt(this.$route.params.sub_level);
            console.log('🔍 Mounted - user_level set to:', this.user_level);
            console.log('🔍 Mounted - currentUser.user_level:', this.currentUser.user_level);
            
            this.loadFilterData();
            this.fetchCanUpdatePayment();
            this.getQVPList('general');
            this.$root.updateParent(this.$t('qvp_registrants_list') || 'QVP Registrants List');
        }

        window.onpopstate = function() {
            if ($('body').hasClass('modal-open')) {
                location.reload();
            }
        };
    },
    methods: {
        getQVPList(tabType, page = 1) {
            this.current_tab = tabType;
            this.loading_list = true;
            
            // Prepare data for API call
            const data = {
                category: tabType,
                per_page: 20,
                // page is in URL, don't include in body
                q: this.search_query || '' // Search query
            };
            
            // Get user information
            const user = this.currentUser;
            const userLevel = this.user_level ?? (user?.user_level ?? 0);
            
            // For state admin (level 1 or 0), don't add any filters - see all registrations
            // For other levels, filter by their location
            if (userLevel === 2) {
                // District admin - use route param if available, otherwise use user's district_id
                if (this.$route.params.id) {
                    data.district_id = parseInt(this.$route.params.id);
                } else if (user?.district_id) {
                    data.district_id = parseInt(user.district_id);
                }
            } else if (userLevel === 3) {
                // Zone admin - use route param if available, otherwise use user's zone_id
                if (this.$route.params.id) {
                    data.zone_id = parseInt(this.$route.params.id);
                } else if (user?.zone_id) {
                    data.zone_id = parseInt(user.zone_id);
                }
            } else if (userLevel === 4) {
                // Unit admin - use route param if available, otherwise use user's unit_id
                if (this.$route.params.id) {
                    data.unit_id = parseInt(this.$route.params.id);
                } else if (user?.unit_id) {
                    data.unit_id = parseInt(user.unit_id);
                }
            }
            // For state admin (level 1 or 0), no filters added - will see all registrations
            
            // Apply filters if set
            if (this.filters.district) {
                data.district_id = parseInt(this.filters.district);
            }
            if (this.filters.zone) {
                data.zone_id = parseInt(this.filters.zone);
            }
            if (this.filters.unit) {
                data.unit_id = parseInt(this.filters.unit);
            }
            if (this.filters.registration_type) {
                data.registration_type = this.filters.registration_type;
                console.log('🔍 Applying registration_type filter:', this.filters.registration_type);
            }
            
            console.log('QVP registrants request data:', data);
            console.log('QVP registrants request URL:', `get-qvp-registrants?page=${page}`);
            
            // Add cache-busting timestamp to ensure fresh data
            const timestamp = new Date().getTime();
            
            // Use appropriate API endpoint - adjust based on your backend
            UserService.authPostRequest(`get-qvp-registrants?page=${page}&_t=${timestamp}`, data).then(
                (response) => {
                    console.log('QVP registrants response:', response.data);
                    
                    if (response.data.status == 'success' && response.data.data && response.data.data.list) {
                        // Get the paginated list
                        const paginatedList = response.data.data.list;
                        const registrantList = paginatedList.data || [];
                        
                        console.log('QVP registrants loaded:', registrantList.length, 'items');
                        
                        // Store the registrant list
                        this.grouped_registrants[this.current_tab] = registrantList;
                        this.registrant_lists = registrantList;
                        
                        // Store pagination information
                        this.pagination_data[this.current_tab] = {
                            current_page: paginatedList.current_page || page,
                            total: paginatedList.total || 0,
                            per_page: paginatedList.per_page || 20,
                            from: paginatedList.from || 1
                        };
                        
                        // Store other response data
                        this.permissions = response.data.data.permissions || {};
                        this.download_link = response.data.data.download_url || '';
                        
                        // Store category counts from API (total across all pages)
                        if (response.data.data.category_counts) {
                            this.category_counts_from_api = response.data.data.category_counts;
                        }
                        
                        this.message = response.data.message || '';
                        this.loading_list = false;
                        
                        console.log(`QVP registrants loaded: ${registrantList.length} items`);
                        console.log('Category counts from API:', this.category_counts_from_api);
                        
                    } else {
                        // No data or empty response
                        this.grouped_registrants[this.current_tab] = [];
                        this.registrant_lists = [];
                        this.message = response.data.message || 'No QVP registrants found for this category';
                        this.loading_list = false;
                        console.log('No QVP registrants found:', response.data);
                    }
                },
                (error) => {
                    console.error('QVP registrants fetch error:', error);
                    console.error('Error response:', error.response);
                    console.error('Error data:', error.response?.data);
                    console.error('Error status:', error.response?.status);
                    
                    this.grouped_registrants[this.current_tab] = [];
                    this.registrant_lists = [];
                    
                    // Show detailed error message
                    let errorMessage = 'Error loading QVP registrants';
                    if (error.response) {
                        if (error.response.status === 500) {
                            errorMessage = 'Server error. Please contact support or try again later.';
                        } else if (error.response.data && error.response.data.message) {
                            errorMessage = error.response.data.message;
                        } else {
                            errorMessage = `Error ${error.response.status}: ${error.response.statusText || 'Unknown error'}`;
                        }
                    } else if (error.message) {
                        errorMessage = error.message;
                    }
                    
                    this.message = errorMessage;
                    this.loading_list = false;
                    
                    // Show alert for 500 errors
                    if (error.response && error.response.status === 500) {
                        this.showAlert(errorMessage, 'error');
                    }
                }
            );
        },
        
        getCategoryDisplayName(category, kidsSubcategory = null) {
            const categoryNames = {
                'general': 'ജനറൽ (General)',
                'campus': 'അൽ ബയാൻ (Al Bayan)',
                'teens': 'ടീൻസ് (Teens)',
                'kids': kidsSubcategory === 'Junior' ? 'കിഡ്സ് - ജൂനിയർ' : kidsSubcategory === 'Senior' ? 'കിഡ്സ് - സീനിയർ' : 'കിഡ്സ് (Kids)',
                'global': 'ഗ്ലോബൽ (Global)'
            };
            return categoryNames[category] || category;
        },
        
        // Handle pagination page changes
        handlePageChange(page) {
            console.log('Page change requested:', page, 'for tab:', this.current_tab);
            this.pagination_data[this.current_tab].current_page = page;
            this.getQVPList(this.current_tab, page);
        },
        
        // Search functionality methods
        handleSearch() {
            // Clear existing timeout
            if (this.search_timeout) {
                clearTimeout(this.search_timeout);
            }
            
            // Set new timeout for debounced search (wait 500ms after user stops typing)
            this.search_timeout = setTimeout(() => {
                // Reset to page 1 when searching
                this.pagination_data[this.current_tab].current_page = 1;
                // Trigger search by reloading the current tab
                this.getQVPList(this.current_tab, 1);
            }, 500);
        },
        
        clearSearch() {
            this.search_query = '';
            // Reset to page 1 and reload
            this.pagination_data[this.current_tab].current_page = 1;
            this.getQVPList(this.current_tab, 1);
        },
        
        downloadPDF() {
            if (this.download_link) {
                window.open(this.download_link, '_blank');
            } else {
                this.alert_type = 'Warning';
                this.alert_message = 'Download link not available';
                this.$refs.alert_model.openModel();
            }
        },
        
        showActionModel() {
            // Action model handler
        },
        
        isPublicRegistration(registrant) {
            // Check if registration came from public /qvp route (online registration)
            if (!registrant) return false;
            const rt = String(registrant.registration_type || '').toLowerCase().trim();
            return rt === 'public' || rt === 'online';
        },
        
        // Kids Registration Modal Methods
        openKidsRegistrationModal() {
            this.showKidsModal = true;
            this.resetKidsForm();
            
            // Load data based on admin level
            if (this.isStateAdmin) {
                // State admin: Load all districts, ensure zone_id is cleared
                this.kidsForm.zone_id = '';
                this.kidsForm.district_id = ''; // Clear district selection
                this.zones = []; // Clear zones for state admin
                this.loadAllDistricts();
            } else if (this.isDistrictAdmin) {
                // District admin: Use route param if available, otherwise use user's district_id
                let districtId = null;
                if (this.$route.params.id) {
                    districtId = parseInt(this.$route.params.id);
                } else if (this.currentUser && this.currentUser.district_id) {
                    districtId = parseInt(this.currentUser.district_id);
                }
                
                if (districtId) {
                    this.kidsForm.district_id = districtId;
                    this.loadZonesForDistrict(districtId);
                }
            } else if (this.isZoneAdmin) {
                // Zone admin: Use route param if available, otherwise use user's zone_id
                let zoneId = null;
                if (this.$route.params.id) {
                    zoneId = parseInt(this.$route.params.id);
                } else if (this.currentUser && this.currentUser.zone_id) {
                    zoneId = parseInt(this.currentUser.zone_id);
                }
                
                // Set district_id from route or user
                if (this.currentUser && this.currentUser.district_id) {
                    this.kidsForm.district_id = this.currentUser.district_id;
                }
                
                if (zoneId) {
                    this.kidsForm.zone_id = zoneId;
                }
                // Don't load zones - zone admin only needs place field
            }
            
            // Prevent body scroll when modal is open
            document.body.style.overflow = 'hidden';
        },
        
        closeKidsModal() {
            this.showKidsModal = false;
            this.resetKidsForm();
            // Restore body scroll
            document.body.style.overflow = '';
        },
        
        resetKidsForm() {
            this.kidsForm = {
                name: '',
                age: '',
                gender: '',
                kids_subcategory: '',
                parent_name: '',
                parent_mobile: '',
                revenue_district_id: '',
                district_id: '',
                zone_id: '',
                unit_id: '',
                place: ''
            };
            this.zones = [];
            this.kidsUnits = [];
            // Don't reset district_id for district admin - it should remain set
            if (this.isDistrictAdmin) {
                let districtId = null;
                if (this.$route.params.id) {
                    districtId = parseInt(this.$route.params.id);
                } else if (this.currentUser && this.currentUser.district_id) {
                    districtId = parseInt(this.currentUser.district_id);
                }
                if (districtId) {
                    this.kidsForm.district_id = districtId;
                }
            }
            // Don't reset district_id and zone_id for zone admin - they should remain set
            if (this.isZoneAdmin) {
                let zoneId = null;
                if (this.$route.params.id) {
                    zoneId = parseInt(this.$route.params.id);
                } else if (this.currentUser && this.currentUser.zone_id) {
                    zoneId = parseInt(this.currentUser.zone_id);
                }
                
                if (this.currentUser && this.currentUser.district_id) {
                    this.kidsForm.district_id = this.currentUser.district_id;
                }
                
                if (zoneId) {
                    this.kidsForm.zone_id = zoneId;
                }
                // Load units for zone so user can pick unit
                if (zoneId) {
                    this.loadKidsUnitsForZone(zoneId);
                }
            }
            // For state admin, ensure zone_id is always cleared (never use admin's zone)
            if (this.isStateAdmin) {
                this.kidsForm.zone_id = '';
            }
            // For unit admin, auto-set district/zone/unit from route or profile
            if (this.isUnitAdmin) {
                const unitId = this.$route.params.id ? parseInt(this.$route.params.id) : parseInt(this.currentUser?.unit_id || 0);
                if (this.currentUser?.district_id) this.kidsForm.district_id = this.currentUser.district_id;
                if (this.currentUser?.zone_id) this.kidsForm.zone_id = this.currentUser.zone_id;
                if (unitId) this.kidsForm.unit_id = unitId;
            }
        },
        
        handleKidsAgeChange() {
            // Auto-select kids sub-category based on age
            if (this.kidsForm.age) {
                const age = parseInt(this.kidsForm.age);
                const currentYear = new Date().getFullYear();
                const birthYear = currentYear - age;
                
                if (birthYear > 2017) {
                    this.kidsForm.kids_subcategory = 'junior';
                } else if (birthYear >= 2014 && birthYear <= 2017) {
                    this.kidsForm.kids_subcategory = 'senior';
                } else {
                    this.kidsForm.kids_subcategory = '';
                }
            }
        },
        
        async loadAllDistricts() {
            // Load all districts for state admin using district_id (not revenue_district_id)
            try {
                const data = {};
                const response = await UserService.authPostRequest('get-district-by-id', data);
                if (response.data.status === 'success') {
                    this.allDistricts = response.data.data.list || [];
                    console.log('Districts loaded:', this.allDistricts.length);
                } else {
                    console.error('Failed to load districts:', response.data.message);
                    this.allDistricts = [];
                }
            } catch (error) {
                console.error('Error loading districts:', error);
                this.allDistricts = [];
                // Show error message to user
                this.showAlert('ജില്ലകൾ ലോഡ് ചെയ്യുന്നതിൽ പരാജയം. ദയവായി വീണ്ടും ശ്രമിക്കുക.', 'error');
            }
        },
        
        async handleDistrictChange(event) {
            // Get the value from the event if available, otherwise use v-model
            let selectedDistrictId = null;
            if (event && event.target && event.target.value !== undefined) {
                selectedDistrictId = event.target.value;
                console.log('District changed via event, event.target.value:', selectedDistrictId);
                // CRITICAL: Update v-model with the event value
                this.kidsForm.district_id = selectedDistrictId;
            } else {
                selectedDistrictId = this.kidsForm.district_id;
                console.log('District changed via v-model, kidsForm.district_id:', selectedDistrictId);
            }
            
            // CRITICAL: Use the value from v-model as the source of truth
            selectedDistrictId = this.kidsForm.district_id;
            
            console.log('=== DISTRICT CHANGED ===');
            console.log('Selected district_id:', selectedDistrictId);
            console.log('Type of selectedDistrictId:', typeof selectedDistrictId);
            console.log('Admin user district_id:', this.currentUser?.district_id);
            console.log('Are they different?', selectedDistrictId != this.currentUser?.district_id);
            console.log('Current kidsForm.district_id:', this.kidsForm.district_id);
            
            // CRITICAL CHECK: If selected district matches admin district, warn
            if (this.isStateAdmin && this.currentUser?.district_id && selectedDistrictId == this.currentUser.district_id) {
                console.warn('⚠️ WARNING: Selected district matches admin district. If you selected a different district, this is a BUG!');
            }
            
            // For state admin: when district is selected, load zones
            // Clear zone_id to prevent showing admin's zone
            this.kidsForm.zone_id = '';
            
            // CRITICAL: Force clear zones array immediately to prevent showing old zones
            this.zones = [];
            // Force Vue to update the DOM
            await this.$nextTick();
            console.log('Zones cleared, DOM updated');
            
            if (!selectedDistrictId) {
                console.log('No district selected, zones cleared');
                return;
            }
            
            const districtId = parseInt(selectedDistrictId);
            if (isNaN(districtId) || districtId <= 0) {
                console.error('Invalid district ID:', selectedDistrictId);
                this.zones = [];
                return;
            }
            
            // IMPORTANT: Verify we're not loading zones for admin's district when a different district is selected
            if (this.isStateAdmin && this.currentUser?.district_id && districtId === parseInt(this.currentUser.district_id)) {
                console.warn('⚠️ Selected district matches admin district - this is OK if intentional');
            } else if (this.isStateAdmin && this.currentUser?.district_id && districtId !== parseInt(this.currentUser.district_id)) {
                console.log('✅ Loading zones for different district than admin district');
            }
            
            console.log('Loading zones for district:', districtId);
            
            // Load zones for the selected district
            await this.loadZonesForDistrict(districtId);
            
            // Ensure zone_id is still cleared after loading zones (prevent auto-selection)
            this.kidsForm.zone_id = '';
            
            // Final verification
            console.log('Final zones count:', this.zones.length);
            if (this.zones.length > 0) {
                const allMatch = this.zones.every(z => parseInt(z.district_id) === districtId);
                console.log('All zones match selected district:', allMatch);
                if (!allMatch) {
                    console.error('❌ ERROR: Some zones do not match selected district!');
                    this.zones = this.zones.filter(z => parseInt(z.district_id) === districtId);
                    console.log('Filtered zones count:', this.zones.length);
                }
            }
        },
        
        async loadZonesForDistrict(districtId) {
            // Load zones for a specific district_id
            try {
                // CRITICAL: Ensure we're using the passed districtId, not the admin's district_id
                const requestedDistrictId = districtId;
                const adminDistrictId = this.currentUser?.district_id;
                
                console.log('=== loadZonesForDistrict CALLED ===');
                console.log('Requested districtId parameter:', requestedDistrictId);
                console.log('Admin district_id:', adminDistrictId);
                console.log('kidsForm.district_id:', this.kidsForm.district_id);
                
                // Ensure districtId is a number
                const numericDistrictId = parseInt(requestedDistrictId);
                if (isNaN(numericDistrictId) || numericDistrictId <= 0) {
                    console.error('Invalid district ID:', requestedDistrictId);
                    this.zones = [];
                    return;
                }
                
                // CRITICAL CHECK: Verify we're not accidentally using admin's district_id
                if (this.isStateAdmin && adminDistrictId && numericDistrictId === parseInt(adminDistrictId)) {
                    console.warn('⚠️ WARNING: Loading zones for admin district. Make sure this is intentional!');
                    console.warn('If you selected a different district, this is a BUG!');
                }
                
                // Clear zones first to ensure clean state
                this.zones = [];
                console.log('Zones cleared before loading new ones');
                
                const data = {
                    district_id: numericDistrictId
                };
                
                console.log('=== LOADING ZONES ===');
                console.log('Requesting zones for district_id:', numericDistrictId);
                console.log('Admin user district_id:', adminDistrictId);
                console.log('Request data object:', data);
                console.log('Request data JSON:', JSON.stringify(data));
                console.log('Type of district_id in request:', typeof data.district_id);
                console.log('⚠️ VERIFY: district_id in request should be', numericDistrictId, 'NOT', adminDistrictId);
                
                const response = await UserService.authPostRequest('get-zone-by-id', data);
                
                console.log('=== API RESPONSE ===');
                console.log('API Response status:', response.data.status);
                console.log('Full API Response:', response.data);
                console.log('Response zones count:', response.data.data?.list?.length || 0);
                
                if (response.data.status === 'success') {
                    const loadedZones = response.data.data.list || [];
                    console.log('=== PROCESSING ZONES ===');
                    console.log('Zones received from API for district', numericDistrictId, ':', loadedZones.length);
                    console.log('Requested district_id:', numericDistrictId);
                    
                    if (loadedZones.length > 0) {
                        console.log('All zones with their district_ids:');
                        loadedZones.forEach((z, index) => {
                            const zoneDistrictId = parseInt(z.district_id);
                            const matches = zoneDistrictId === numericDistrictId;
                            const matchIcon = matches ? '✅' : '❌';
                            console.log(`${matchIcon} [${index + 1}] ${z.name} (Zone ID: ${z.id}, district_id: ${zoneDistrictId}, requested: ${numericDistrictId})`);
                        });
                    }
                    
                    // Verify all zones belong to the requested district
                    const filteredZones = loadedZones.filter(zone => {
                        const zoneDistrictId = parseInt(zone.district_id);
                        const matches = zoneDistrictId === numericDistrictId;
                        if (!matches) {
                            console.error(`❌ Zone "${zone.name}" (ID: ${zone.id}) has district_id ${zoneDistrictId}, expected ${numericDistrictId}`);
                        }
                        return matches;
                    });
                    
                    if (filteredZones.length !== loadedZones.length) {
                        console.error(`❌ CRITICAL: ${loadedZones.length - filteredZones.length} zones do not belong to district ${numericDistrictId}!`);
                        console.error(`Filtered: ${filteredZones.length} from ${loadedZones.length}`);
                        console.error('This means the API returned zones from the wrong district!');
                    } else {
                        console.log(`✅ All ${filteredZones.length} zones belong to district ${numericDistrictId}`);
                    }
                    
                    // Direct assignment works in Vue 3 (no need for $set)
                    // Create a completely new array to ensure Vue reactivity
                    // Clear first, then set to ensure no stale data
                    this.zones = [];
                    await this.$nextTick();
                    
                    // Now set the new zones
                    this.zones = filteredZones.map(z => ({ ...z })); // Create new objects to ensure reactivity
                    
                    console.log('✅ Zones set in component:', this.zones.length);
                    console.log('Zone names:', this.zones.map(z => z.name).join(', '));
                    console.log('All zone district_ids:', this.zones.map(z => `${z.name}: ${z.district_id}`).join(', '));
                    console.log('Requested district_id:', numericDistrictId);
                    
                    // Final verification - all zones MUST belong to requested district
                    const allZonesMatch = this.zones.every(z => parseInt(z.district_id) === numericDistrictId);
                    console.log('All zones belong to requested district:', allZonesMatch);
                    
                    if (!allZonesMatch) {
                        console.error('❌ CRITICAL ERROR: Zones do not match requested district!');
                        console.error('Requested:', numericDistrictId);
                        console.error('Zones district_ids:', this.zones.map(z => z.district_id));
                        // Filter again to be absolutely sure
                        this.zones = this.zones.filter(z => parseInt(z.district_id) === numericDistrictId);
                        console.log('Re-filtered zones count:', this.zones.length);
                    }
                    
                    // Force Vue to update the DOM
                    await this.$nextTick();
                    console.log('DOM updated after setting zones');
                } else {
                    console.error('❌ Failed to load zones:', response.data.message);
                    this.zones = [];
                }
            } catch (error) {
                console.error('❌ Error loading zones:', error);
                console.error('Error details:', error.response?.data || error.message);
                this.zones = [];
                this.showAlert('പ്രദേശങ്ങൾ ലോഡ് ചെയ്യുന്നതിൽ പരാജയം. ദയവായി വീണ്ടും ശ്രമിക്കുക.', 'error');
            }
        },
        
        handleZoneChange() {
            // For state admin, district_id should already be set from district selection
            // Only set district_id from zone if we're not a state admin and district_id is not set
            if (this.kidsForm.zone_id && !this.isStateAdmin && !this.kidsForm.district_id) {
                const selectedZone = this.zones.find(z => z.id == this.kidsForm.zone_id);
                if (selectedZone && selectedZone.district_id) {
                    this.kidsForm.district_id = selectedZone.district_id;
                }
            }
            // For state admin, validate that selected zone belongs to selected district
            if (this.isStateAdmin && this.kidsForm.zone_id && this.kidsForm.district_id) {
                const selectedZone = this.zones.find(z => z.id == this.kidsForm.zone_id);
                if (selectedZone) {
                    // Verify zone belongs to the selected district
                    if (selectedZone.district_id && selectedZone.district_id != this.kidsForm.district_id) {
                        // Zone doesn't belong to selected district - clear it and show error
                        console.error('Selected zone does not belong to selected district. Clearing zone selection.');
                        this.kidsForm.zone_id = '';
                        this.showAlert('ദയവായി തിരഞ്ഞെടുത്ത ജില്ലയുമായി ബന്ധപ്പെട്ട പ്രദേശം തിരഞ്ഞെടുക്കുക', 'error');
                    }
                }
            }
            // Whenever zone changes, reload units and clear selected unit
            if (this.kidsForm.zone_id) {
                this.kidsForm.unit_id = '';
                this.loadKidsUnitsForZone(this.kidsForm.zone_id);
            } else {
                this.kidsForm.unit_id = '';
                this.kidsUnits = [];
            }
        },

        handleUnitChange() {
            // Placeholder for any future unit-dependent logic
        },

        async loadKidsUnitsForZone(zoneId) {
            try {
                const zid = parseInt(zoneId);
                if (!zid) {
                    this.kidsUnits = [];
                    return;
                }
                const response = await UserService.authPostRequest('get-unit-by-id', { zone_id: zid });
                if (response.data.status === 'success') {
                    this.kidsUnits = response.data.data.list || [];
                } else {
                    this.kidsUnits = [];
                }
            } catch (error) {
                console.error('Error loading kids units:', error);
                this.kidsUnits = [];
            }
        },
        
        async handleKidsRegistration() {
            // Validate form
            if (!this.kidsForm.name) {
                this.showAlert('ദയവായി കുട്ടിയുടെ പേര് നൽകുക', 'error');
                return;
            }
            if (!this.kidsForm.age || this.kidsForm.age < 1 || this.kidsForm.age > 12) {
                this.showAlert('ദയവായി സാധുവായ പ്രായം നൽകുക (1-12)', 'error');
                return;
            }
            if (!this.kidsForm.gender) {
                this.showAlert('ദയവായി Gender തിരഞ്ഞെടുക്കുക', 'error');
                return;
            }
            if (!this.kidsForm.kids_subcategory) {
                this.showAlert('ദയവായി Kids Category തിരഞ്ഞെടുക്കുക', 'error');
                return;
            }
            if (!this.kidsForm.parent_name) {
                this.showAlert('ദയവായി Parent Name നൽകുക', 'error');
                return;
            }
            if (!this.kidsForm.parent_mobile || this.kidsForm.parent_mobile.length !== 10) {
                this.showAlert('ദയവായി സാധുവായ 10 അക്ക Parent Mobile Number നൽകുക', 'error');
                return;
            }
            // For state admin, district is required
            if (this.isStateAdmin && !this.kidsForm.district_id) {
                this.showAlert('ദയവായി ജില്ല തിരഞ്ഞെടുക്കുക', 'error');
                return;
            }
            // For district admin, district_id should already be set from user profile
            if (this.isDistrictAdmin && !this.kidsForm.district_id) {
                this.showAlert('District information not found', 'error');
                return;
            }
            // For zone admin, district_id and zone_id should already be set from user profile, and place is required
            if (this.isZoneAdmin) {
                if (!this.kidsForm.district_id || !this.kidsForm.zone_id) {
                    this.showAlert('District or Zone information not found', 'error');
                    return;
                }
                if (!this.kidsForm.unit_id) {
                    this.showAlert('ദയവായി Unit തിരഞ്ഞെടുക്കുക', 'error');
                    return;
                }
                if (!this.kidsForm.place) {
                    this.showAlert('ദയവായി സ്ഥലം നൽകുക', 'error');
                    return;
                }
            }
            // Zone is required for state and district admins (zone admin only needs place)
            if (!this.isZoneAdmin && !this.kidsForm.zone_id) {
                this.showAlert('ദയവായി Area തിരഞ്ഞെടുക്കുക', 'error');
                return;
            }
            // Unit required for state/district admins (unit admin auto sets)
            if (!this.isZoneAdmin && !this.isUnitAdmin && !this.kidsForm.unit_id) {
                this.showAlert('ദയവായി Unit തിരഞ്ഞെടുക്കുക', 'error');
                return;
            }
            
            this.loadingKidsRegistration = true;
            
            try {
                // Determine district_id and zone_id based on admin level
                let finalDistrictId = null;
                let finalZoneId = null;
                let finalUnitId = null;
                
                if (this.isStateAdmin) {
                    // State admin: use selected district_id and zone_id
                    finalDistrictId = this.kidsForm.district_id;
                    finalZoneId = this.kidsForm.zone_id;
                    finalUnitId = this.kidsForm.unit_id;
                } else if (this.isDistrictAdmin) {
                    // District admin: use the district from route params (the district being viewed)
                    // If route param exists, use it; otherwise fall back to user's district or form district
                    finalDistrictId = this.$route.params.id ? parseInt(this.$route.params.id) : (this.currentUser?.district_id || this.kidsForm.district_id);
                    finalZoneId = this.kidsForm.zone_id;
                    finalUnitId = this.kidsForm.unit_id;
                } else if (this.isZoneAdmin) {
                    // Zone admin: always use user's district_id and zone_id (not the selected zone)
                    finalDistrictId = this.currentUser?.district_id;
                    finalZoneId = this.currentUser?.zone_id;
                    finalUnitId = this.kidsForm.unit_id;
                } else if (this.isUnitAdmin) {
                    finalDistrictId = this.currentUser?.district_id;
                    finalZoneId = this.currentUser?.zone_id;
                    finalUnitId = this.$route.params.id ? parseInt(this.$route.params.id) : this.currentUser?.unit_id;
                }
                
                // Prepare registration data
                // For kids, use parent_mobile as the mobile number
                const parentMobile = this.kidsForm.parent_mobile;
                
                const registrationData = {
                    form_name: 'QVP_REGISTRATION',
                    new_reg: true,
                    registration_source: 'admin', // Mark as admin registration (not public)
                    new: {
                        name: this.kidsForm.name,
                        age: this.kidsForm.age,
                        gender: this.kidsForm.gender,
                        category: 'kids',
                        kids_subcategory: this.kidsForm.kids_subcategory,
                        parent_name: this.kidsForm.parent_name,
                        parent_mobile: this.kidsForm.parent_mobile,
                        mobile: parentMobile,
                        code: '91',
                        district_id: finalDistrictId,
                        zone_id: finalZoneId,
                        unit_id: finalUnitId,
                        place: this.isZoneAdmin ? this.kidsForm.place : null, // Place is required for zone admin
                        registration_type: 'member' // Backend expects 'member' for admin registrations
                    }
                };
                
                const response = await UserService.authPostRequest('auto-form-submit', registrationData);
                
                console.log('Kids registration response:', response.data);
                console.log('Registered kid data:', response.data.data);
                
                if (response.data.status === 'success') {
                    this.showAlert('കുട്ടി വിജയകരമായി രജിസ്റ്റർ ചെയ്തു!', 'success');
                    this.closeKidsModal();
                    // Reload the kids tab to show the newly added kid
                    // The backend will filter based on current route params
                    setTimeout(() => {
                        this.current_tab = 'kids';
                        this.getQVPList('kids', 1);
                    }, 1000);
                } else {
                    this.showAlert(response.data.message || 'രജിസ്ട്രേഷൻ പരാജയപ്പെട്ടു', 'error');
                }
            } catch (error) {
                console.error('Kids registration error:', error);
                const errorMessage = error.response?.data?.message || 'രജിസ്ട്രേഷൻ പരാജയപ്പെട്ടു. ദയവായി വീണ്ടും ശ്രമിക്കുക.';
                this.showAlert(errorMessage, 'error');
            } finally {
                this.loadingKidsRegistration = false;
            }
        },
        
        showAlert(message, type) {
            this.alertMessage = message;
            this.alertClass = type === 'error' ? 'alert-error' : 'alert-success';
            // Show the action sheet
            $('#actionSheetAlert').modal('show');
        },
        
        closeAlertModal() {
            $('#actionSheetAlert').modal('hide');
            this.hideAlert();
        },
        
        hideAlert() {
            this.alertMessage = '';
            this.alertClass = '';
        },

        async fetchCanUpdatePayment() {
            try {
                const response = await UserService.authPostRequest('can-update-qvp-payment', {});
                this.canUpdatePayment = response.data?.data?.can_update === true;
            } catch (e) {
                this.canUpdatePayment = false;
            }
        },

        openPaymentStatusModal(registrant) {
            this.selectedRegistrant = registrant;
            // Convert "Pending" to "Not Paid" for display, but keep actual value for backend
            const status = registrant.payment_status || '';
            this.selectedPaymentStatus = status === 'Pending' ? 'Pending' : (status === 'Paid' ? 'Paid' : '');
            this.paymentStatusMessage = '';
            $('#paymentStatusModel').modal('show');
        },
        
        closePaymentStatusModal() {
            $('#paymentStatusModel').modal('hide');
            this.selectedRegistrant = null;
            this.selectedPaymentStatus = '';
            this.paymentStatusMessage = '';
        },
        
        async savePaymentStatus() {
            if (!this.selectedRegistrant || !this.selectedRegistrant.id) {
                this.paymentStatusMessage = 'Invalid registrant data';
                return;
            }
            
            if (!this.selectedPaymentStatus) {
                this.paymentStatusMessage = 'Please select a payment status';
                return;
            }
            
            this.loading = true;
            this.paymentStatusMessage = '';
            
            try {
                // Convert "Not Paid" (display value) to "Pending" (backend value)
                const backendStatus = this.selectedPaymentStatus === 'Pending' ? 'Pending' : this.selectedPaymentStatus;
                
                const data = {
                    id: this.selectedRegistrant.id,
                    payment_status: backendStatus,
                    category: this.selectedRegistrant.category
                };
                
                const response = await UserService.authPostRequest('update-qvp-payment-status', data);
                
                if (response.data.status === 'success') {
                    // Update the registrant's payment status in the list
                    this.selectedRegistrant.payment_status = backendStatus;
                    // Reload the list to reflect the change
                    this.getQVPList(this.current_tab, this.pagination_data[this.current_tab].current_page);
                    this.closePaymentStatusModal();
                    this.showAlert(response.data.message || 'Payment status updated successfully', 'success');
                } else {
                    this.paymentStatusMessage = response.data.message || 'Failed to update payment status';
                }
            } catch (error) {
                console.error('Payment status update error:', error);
                this.paymentStatusMessage = error.response?.data?.message || 'Failed to update payment status. Please try again.';
            } finally {
                this.loading = false;
            }
        },
        
        getRegistrationFee() {
            // All categories have the same registration fee of ₹30
            return 30;
        },
        
        initiatePayment() {
            if (!this.selectedRegistrant || !this.selectedRegistrant.id) {
                this.paymentStatusMessage = 'Invalid registrant data';
                return;
            }
            
            if (!this.currentUser) {
                this.paymentStatusMessage = 'User not logged in';
                return;
            }
            
            // Get the QVP ID (exam_reg_id or id)
            const qvpId = this.selectedRegistrant.exam_reg_id || this.selectedRegistrant.id;
            
            // Redirect to payment gateway URL (same as QVPExamRegistration.vue)
            const paymentUrl = `https://guide.msoftit.com/payment?gway=razorpay&user_id=${this.currentUser.id}&qvp_id=${qvpId}`;
            
            // Close modal and redirect
            this.closePaymentStatusModal();
            window.location.href = paymentUrl;
        },
        
        // Filter methods
        async loadFilterData() {
            // Use route-based user level, falling back to user's actual level
            const userLevel = this.user_level ?? parseInt(this.currentUser?.user_level || 0);
            
            console.log('🔍 loadFilterData - userLevel:', userLevel);
            console.log('🔍 loadFilterData - route params:', this.$route.params);
            
            // Load districts for state admins
            if (userLevel === 0 || userLevel === 1) {
                try {
                    const response = await UserService.authPostRequest('get-district-by-id', {});
                    if (response.data.status === 'success') {
                        this.districtsList = response.data.data.list || [];
                        console.log('✅ Loaded districts:', this.districtsList.length);
                    }
                } catch (error) {
                    console.error('Error loading districts:', error);
                }
            }
            
            // Load zones for state and district admins
            if (userLevel === 0 || userLevel === 1 || userLevel === 2) {
                try {
                    const zoneParams = {};
                    if (userLevel === 2) {
                        // District admin - get zones for their district
                        // Use route param if available, otherwise use user's district_id
                        if (this.$route.params.id) {
                            zoneParams.district_id = parseInt(this.$route.params.id);
                            console.log('🔍 Using district_id from route:', zoneParams.district_id);
                        } else if (this.currentUser.district_id) {
                            zoneParams.district_id = this.currentUser.district_id;
                            console.log('🔍 Using district_id from user:', zoneParams.district_id);
                        }
                    }
                    console.log('🔍 Zone params:', zoneParams);
                    const response = await UserService.authPostRequest('get-zone-by-id', zoneParams);
                    console.log('🔍 Zone response:', response.data);
                    if (response.data.status === 'success') {
                        this.zonesList = response.data.data.list || [];
                        console.log('✅ Loaded zones:', this.zonesList.length, this.zonesList);
                    }
                } catch (error) {
                    console.error('❌ Error loading zones:', error);
                }
            }
            
            // Load units for state, district, and zone admins
            if (userLevel === 0 || userLevel === 1 || userLevel === 2 || userLevel === 3) {
                try {
                    const unitParams = {};
                    if (userLevel === 3) {
                        // Zone admin - get units for their zone
                        // Use route param if available, otherwise use user's zone_id
                        if (this.$route.params.id) {
                            unitParams.zone_id = parseInt(this.$route.params.id);
                        } else if (this.currentUser.zone_id) {
                            unitParams.zone_id = this.currentUser.zone_id;
                        }
                    } else if (userLevel === 2) {
                        // District admin - get units for their district
                        // Use route param if available, otherwise use user's district_id
                        if (this.$route.params.id) {
                            unitParams.district_id = parseInt(this.$route.params.id);
                        } else if (this.currentUser.district_id) {
                            unitParams.district_id = this.currentUser.district_id;
                        }
                    }
                    console.log('🔍 Unit params:', unitParams);
                    const response = await UserService.authPostRequest('get-unit-by-id', unitParams);
                    if (response.data.status === 'success') {
                        this.unitsList = response.data.data.list || [];
                        console.log('✅ Loaded units:', this.unitsList.length);
                    }
                } catch (error) {
                    console.error('Error loading units:', error);
                }
            }
        },
        
        async onDistrictFilterChange() {
            // When district changes, reload zones for that district
            if (this.filters.district) {
                try {
                    const response = await UserService.authPostRequest('get-zone-by-id', {
                        district_id: parseInt(this.filters.district)
                    });
                    if (response.data.status === 'success') {
                        this.zonesList = response.data.data.list || [];
                        this.filters.zone = ''; // Reset zone filter
                        this.filters.unit = ''; // Reset unit filter
                        this.unitsList = []; // Clear units list
                    }
                } catch (error) {
                    console.error('Error loading zones for district:', error);
                }
            } else {
                // If district is cleared, reload all zones
                this.loadFilterData();
            }
        },
        
        async onZoneFilterChange() {
            // When zone changes, reload units for that zone
            if (this.filters.zone) {
                try {
                    const response = await UserService.authPostRequest('get-unit-by-id', {
                        zone_id: parseInt(this.filters.zone)
                    });
                    if (response.data.status === 'success') {
                        this.unitsList = response.data.data.list || [];
                        this.filters.unit = ''; // Reset unit filter
                    }
                } catch (error) {
                    console.error('Error loading units for zone:', error);
                }
            } else {
                // If zone is cleared, reload all units
                this.loadFilterData();
            }
        },
        
        clearFilters() {
            this.filters.district = '';
            this.filters.zone = '';
            this.filters.unit = '';
            this.filters.registration_type = '';
            this.loadFilterData(); // Reload filter data
            this.getQVPList(this.current_tab, 1); // Reload list
        },
        
        applyFilters() {
            // Reset to page 1 when applying filters
            this.pagination_data[this.current_tab].current_page = 1;
            this.getQVPList(this.current_tab, 1);
        }
    }
};
</script>

<style scoped>
.public-qvp-bg {
    /* Public /qvp page background only */
    background: linear-gradient(180deg, #f7f3ff 0%, #ffffff 55%);
    min-height: 100vh;
}
.section-heading {
    padding: 10px 10px 0px 10px;
    margin-bottom: 0px;
}

.error-feedback {
    color: red;
}

.sl-no {
    font-weight: 900;
    margin-right: 12px;
}

.min-width-50 {
    min-width: 60% !important;
}

.section-heading .btn {
    height: 40px;
}

.section-heading .btn ion-icon {
    font-size: 20px;
    margin-right: 6px;
}

/* Search Section Styles */
.search-section {
    padding: 8px 16px;
    margin: 0;
}

.search-box {
    width: 100%;
    position: relative;
}

.search-box .input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}

.search-input {
    width: 100%;
    padding: 10px 40px 10px 40px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 14px;
    transition: all 0.3s ease;
    background-color: #ffffff;
}

.search-input:focus {
    outline: none;
    border-color: #2355b3;
    box-shadow: 0 0 0 3px rgba(35, 85, 179, 0.1);
}

.search-icon {
    position: absolute;
    left: 12px;
    font-size: 20px;
    color: #6b7280;
    pointer-events: none;
}

.clear-search-btn {
    position: absolute;
    right: 8px;
    background: none;
    border: none;
    padding: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6b7280;
    transition: color 0.2s ease;
}

.clear-search-btn:hover {
    color: #dc3545;
}

.clear-search-btn ion-icon {
    font-size: 20px;
}

.download-section {
    padding: 4px 16px 2px 16px;
    margin: 0;
}

/* Remove gap between buttons and list */
.listview.image-listview.inset.text {
    margin-top: 0 !important;
    padding-top: 0;
}

/* Adjust list item layout */
.list-item-container {
    position: relative;
    background-color: #ffffff !important;
    border-radius: 8px;
    margin-bottom: 4px;
    transition: background-color 0.2s ease;
    min-height: 60px;
}

.list-item-container:hover {
    background-color: #f8f9fa !important;
}

/* Highlight online/public registrations */
.list-item-container.public-registrant {
    background: linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%) !important;
    border-left: 4px solid #2196F3;
}

.list-item-container.public-registrant:hover {
    background: linear-gradient(135deg, #bbdefb 0%, #e1bee7 100%) !important;
}

.item-content {
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;
    min-height: 60px;
    padding: 8px 0;
}

.item-content .item {
    flex: 1;
    display: flex;
    align-items: center;
}

.item-content .item .in {
    display: flex;
    align-items: center;
    width: 100%;
}

.item-content .item .in .min-width-50 {
    flex: 1;
    min-width: 0;
    padding-right: 50px;
    overflow: hidden;
}

.item-content .item .in .min-width-50 footer {
    word-wrap: break-word;
    overflow-wrap: break-word;
}

.card-button.dropdown {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
}

.action-button-list>li {
    min-height: 1px !important;
}

/* Kids Registration Modal Styles */
.kids-registration-modal {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0);
    z-index: 9999;
    overflow-y: auto;
    transition: background-color 0.3s ease;
}

.kids-registration-modal.modal-open {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.5);
    animation: fadeInBackdrop 0.3s ease;
}

@keyframes fadeInBackdrop {
    from {
        background-color: rgba(0, 0, 0, 0);
    }
    to {
        background-color: rgba(0, 0, 0, 0.5);
    }
}

.modal-content-bottom {
    background: #fff;
    width: 100%;
    max-width: 600px;
    max-height: 90vh;
    border-radius: 20px 20px 0 0;
    transform: translateY(100%);
    transition: transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    overflow-y: auto;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
}

.kids-registration-modal.modal-open .modal-content-bottom {
    transform: translateY(0);
    animation: slideUpModal 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

@keyframes slideUpModal {
    from {
        transform: translateY(100%);
        opacity: 0.9;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
}

.modal-header-bottom {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid #e9ecef;
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 10;
    border-radius: 20px 20px 0 0;
}

.modal-header-bottom .modal-title {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #1a418c;
    text-align: center;
}

.close-btn {
    background: none;
    border: none;
    font-size: 24px;
    color: #6c757d;
    cursor: pointer;
    padding: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: background 0.2s;
}

.close-btn:hover {
    background: #f1f3f5;
    color: #1a418c;
}

.modal-body-bottom {
    padding: 20px;
    padding-bottom: 20px;
}

.modal-body-bottom .form-group {
    margin-bottom: 20px;
}

.modal-body-bottom .form-label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: #1a418c;
    font-size: 14px;
}

.modal-body-bottom .form-control {
    width: 100%;
    padding: 12px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 16px;
    transition: border-color 0.2s, box-shadow 0.2s;
    box-sizing: border-box;
    overflow: visible;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.modal-body-bottom .form-control::placeholder {
    color: #9ca3af;
    opacity: 1;
    overflow: visible;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.modal-body-bottom .form-control:focus {
    outline: none;
    border-color: #1a418c;
    box-shadow: 0 0 0 3px rgba(26, 65, 140, 0.1);
}

/* Select dropdown specific styles */
.modal-body-bottom select.form-control {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 12px center;
    background-size: 16px;
    padding-right: 40px;
    white-space: normal;
    text-overflow: clip;
    overflow: visible;
    height: auto;
    min-height: 48px;
}

.modal-body-bottom select.form-control option {
    padding: 10px;
    white-space: normal;
    overflow: visible;
}

/* Responsive Design */
@media (max-width: 480px) {
    .search-section {
        padding: 8px 12px;
    }
    
    .search-input {
        font-size: 13px;
        padding: 8px 35px 8px 35px;
    }
    
    .modal-content-bottom {
        max-height: 95vh;
        border-radius: 15px 15px 0 0;
    }
    
    .modal-header-bottom {
        padding: 15px;
        border-radius: 15px 15px 0 0;
    }
    
    .modal-body-bottom {
        padding: 15px;
    }
    
    .modal-body-bottom .form-control {
        font-size: 14px;
        padding: 10px;
    }
    
    .modal-body-bottom .form-control::placeholder {
        font-size: 14px;
    }
    
    /* Ensure flex items don't overflow on mobile */
    .modal-body-bottom .form-group[style*="flex"] {
        min-width: 0;
    }
}

/* QVP Summary Statistics Card */
.stat-box {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    border-radius: 10px;
    padding: 10px 10px;
    margin-bottom: 10px;
    text-align: center;
}

.stat-box .title {
    font-size: 12px;
    color: #6c757d;
    font-weight: 500;
    margin-bottom: 5px;
}

.stat-box .value {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 2px;
    line-height: 1.2;
}

@media (max-width: 576px) {
    .stat-box .value {
        font-size: 14px;
    }
    
    .stat-box .title {
        font-size: 10px;
    }
}
</style>

